import React, { useState, useEffect, useRef } from "react";

import "react-toastify/dist/ReactToastify.css";

var Modal = require("react-bootstrap-modal");

export const SafetyFeatures = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  safetyFeatureList,
  save,
  updating,
}) => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  const [safety, setSafety] = useState(formData["safety"] || []);


  const valueRef = useRef(formData);
  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const handleStep = (val) => {
    const ind = safety.indexOf(val);
    const updatedAminities = [...safety];
    if (ind > -1) {
      updatedAminities.splice(ind, 1);
    } else {
      updatedAminities.push(val);
    }
    setSafety(updatedAminities);
    valueRef.current = { ...formData, safety: updatedAminities };
  };

  const handleNextStep = () => {
    valueRef.current = {...formData, safety: [...safety]}
    setFormData({ ...formData, safety: [...safety] });
    if (safety.length) {
      setTimeout(() => {
        save({ safety });
        onNext();
      }, 0); 
    }
  };
  return (
    <div className={className}  ref={elementRef}>
      <div className=" tw-min-h-[60vh]">
        <h4 className="mb-2 tw-flex tw-justify-start tw-items-center">
          <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
            6
          </span>{" "}
          Safety Features
        </h4>
        <div className=" row my-3">
          {safetyFeatureList.map((data) => (
            <div
              key={data.id}
              className="form-check form-check-inline col-lg-3"
            >
              <label className="form-check-label">
                <input
                  type="checkbox"
                  onChange={(e) => handleStep(e.target.value)}
                  checked={safety.includes(data.id)}
                  className="form-check-input tw-h-5 tw-w-5"
                  value={data.id}
                />
                {data.name}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2  tw-mb-2"
        >
          Prev
        </button>

        <button
          disabled={updating}
          onClick={handleNextStep}
          className="btn btn-secondary tw-mb-2"
        >
          {updating ? "Updating ..." : "Save & Next"}
        </button>
      </div>
    </div>
  );
};

export const validateSafety = (formData) => {

  const {safety} = formData
  const errors = [];

  if (!safety) {
    errors.push({
      error: "Safety features field is required",
      errorType: 'safety'
    })
    return { errors, isValid: false };
  }


  if (safety.length === 0) {
    errors.push({
      error: "No safety feature selected. Consider adding at least one safety feature",
      errorType: 'safety'
    })
    return { errors, isValid: false };
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
  };
};